import { Aperture } from "lucide-react";

export const AuthShell = ({ title, kicker, children, image }) => (
  <div className="grid min-h-[calc(100vh-4rem)] lg:grid-cols-2">
    <div className="noise relative hidden overflow-hidden lg:block">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="grid-bg absolute inset-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-[#0A0A0F]/40 to-transparent" />
      <div className="absolute bottom-12 left-12 right-12">
        <Aperture className="h-10 w-10 text-cyan-400" />
        <p className="mt-4 font-display text-5xl font-black uppercase leading-none">Sua lente.<br />Seu pódio.</p>
      </div>
    </div>
    <div className="flex items-center justify-center px-5 py-14">
      <div className="w-full max-w-md">
        <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-cyan-400">{kicker}</p>
        <h1 className="mt-2 font-display text-5xl font-black uppercase">{title}</h1>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </div>
);
